import { __decorate } from "tslib";
import { injectable } from "inversify";
import { ObjectUtils, raise } from "@leavy/utils";
let TrackingEventRegistry = class TrackingEventRegistry {
    constructor() {
        this._eventsByName = new Map();
        this._eventsByConstructor = new Map();
    }
    registerEvents(events) {
        ObjectUtils.entries(events)
            .forEach(([key, value]) => {
            this._eventsByName.set(key, value);
            this._eventsByConstructor.set(value, key);
        });
        return this;
    }
    get registry() {
        return this._eventsByName;
    }
    getEventConstructor(eventName) {
        return this._eventsByName.get(eventName) ?? raise(new Error(`Tracking event constructor for name: ${eventName} not found in the registry.`));
    }
    getEventName(event) {
        const ctor = (typeof event === "function" ? event : event.constructor);
        return this._eventsByConstructor.get(ctor) ?? raise(new Error(`Unknown tracking event constructor`));
    }
};
TrackingEventRegistry = __decorate([
    injectable()
], TrackingEventRegistry);
export { TrackingEventRegistry };
//# sourceMappingURL=TrackingEventRegistry.js.map